"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageManager = void 0;
exports.pageNamedContexts = pageNamedContexts;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockManager = require("../BlockManager");
var _spec = require("../spec");
var _variables = require("@blockwell/variables");
var _remeda = require("remeda");
var _reactivity = require("@vue/reactivity");
var _eventer = require("@blockwell/eventer");
class PageManager {
  static create() {
    return Object.freeze(new PageManager({
      name: "",
      root: {
        type: "layout",
        createCtx: "page"
      }
    }));
  }
  constructor(spec) {
    (0, _defineProperty2.default)(this, "effectHolder", {
      effect: null
    });
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer(false));
    (0, _defineProperty2.default)(this, "rootHolder", {
      block: null
    });
    (0, _defineProperty2.default)(this, "specHolder", void 0);
    (0, _defineProperty2.default)(this, "registryHolder", {
      registry: null
    });
    (0, _defineProperty2.default)(this, "titleHolder", {
      ref: null
    });
    (0, _defineProperty2.default)(this, "parameterVariables", []);
    this.specHolder = {
      spec: (0, _reactivity.reactive)(spec)
    };
    if (!this.specHolder.spec.pathParam) {
      this.specHolder.spec.pathParam = [];
    }
  }
  get spec() {
    return this.specHolder.spec;
  }
  get root() {
    return Object.freeze({
      block: this.rootHolder.block
    });
  }
  get name() {
    return this.specHolder.spec.name;
  }
  get layout() {
    return this.spec.layout;
  }
  get parentContext() {
    return this.spec.parentContext;
  }
  get registry() {
    return this.registryHolder.registry;
  }
  get title() {
    return this.titleHolder.ref;
  }
  attach(registry) {
    this.registryHolder.registry = registry;
  }
  activate(path) {
    var _spec$vars;
    if (!this.registry) {
      throw new Error("Activate PageManager failure, not attached");
    }
    const spec = this.spec.root;
    const block = (0, _spec.addBlock)(spec, this.registry, null);
    this.rootHolder.block = block;
    block.context = new _variables.ContextManager(block.key, typeof spec.createCtx === "string" ? spec.createCtx : "root");
    const root = this.registry.blocks.root;
    const parent = root.findNamedContext(this.parentContext) || root.context;
    parent.addChild(block.context);
    if (this.spec.pathParam) {
      let i = 0;
      for (let it of this.spec.pathParam) {
        this.addPathVariable(it, path[i]);
        ++i;
      }
    }
    if (((_spec$vars = spec.vars) === null || _spec$vars === void 0 ? void 0 : _spec$vars.length) > 0) {
      block.variable.addVariables();
    }
    block.variable.registerVariables();
    (0, _spec.addBlocksFromSpec)(block, spec.children);
    this.titleHolder.ref = new _variables.VariableReference(this.registry.variableTypes.get("template"), {
      template: this.spec.title
    }, true);
    block.context.addVariable(block.key, null, this.titleHolder.ref, "pageManager title");
    return this.root;
  }
  stop() {
    if (this.rootHolder.block) {
      if (this.registry.editor) {
        // Update spec if in editor mode
        this.specHolder.spec.root = this.rootHolder.block.toJSON().block;
      }
      this.rootHolder.block.removeContext();
      this.rootHolder.block.destroyTree();
      this.rootHolder.block = null;
      this.parameterVariables.splice(0);
    }
  }
  destroy() {
    this.stop();
    this.events.clearListeners();
    this.effectHolder.effect = null;
  }
  createPathVariable(val) {
    const writeable = new _variables.WriteableVariable("value");
    const variable = new _variables.VariableReference(writeable, {});
    writeable.set(val);
    return {
      writeable,
      variable
    };
  }
  addPathVariable(spec, pathPart) {
    if (!this.rootHolder.block) {
      return;
    }
    if (spec.name) {
      const val = pathPart || spec.default || "";
      const {
        writeable,
        variable
      } = this.createPathVariable(val);
      this.rootHolder.block.context.addVariable(this.rootHolder.block.key, spec.name, variable, `PageManager page=${this.name} name=${spec.name}`);
      this.parameterVariables.push({
        variable,
        val,
        writeable
      });
    } else {
      // The variable has no name, so it's pointless to add it, but we'll use a null as
      // a placeholder to keep the index numbers consistent.
      this.parameterVariables.push(null);
    }
  }
  updatePath(path) {
    if (!this.rootHolder.block) {
      return;
    }
    let i = 0;
    for (let it of this.parameterVariables) {
      if (it && it.val !== path[i]) {
        it.val = path[i];
        it.writeable.set(path[i]);
      }
      ++i;
    }
  }
  addParameter(spec, currentPath) {
    var _this$registry;
    this.spec.pathParam.push(spec);
    this.addPathVariable(spec, currentPath[this.spec.pathParam.length - 1]);
    (_this$registry = this.registry) === null || _this$registry === void 0 ? void 0 : _this$registry.change({
      type: "page",
      op: "update",
      name: this.name
    });
  }
  removeParameter(index, currentPath) {
    var _this$registry2;
    this.spec.pathParam.splice(index, 1);
    if (this.rootHolder.block) {
      let it = this.parameterVariables[index];
      if (it) {
        this.rootHolder.block.context.removeVariable(it.variable);
      }
      this.parameterVariables.splice(index, 1);
      this.updatePath(currentPath);
    }
    (_this$registry2 = this.registry) === null || _this$registry2 === void 0 ? void 0 : _this$registry2.change({
      type: "page",
      op: "update",
      name: this.name
    });
  }
  updateParameter(index, spec, currentPath) {
    var _this$registry3;
    let nameChange = this.spec.pathParam[index].name !== spec.name;
    this.spec.pathParam[index].name = spec.name;
    this.spec.pathParam[index].default = spec.default;
    if (this.rootHolder.block) {
      const val = currentPath[index] || spec.default || "";
      const it = this.parameterVariables[index];
      if (nameChange) {
        const {
          writeable,
          variable
        } = this.createPathVariable(val);
        if (it) {
          let listeners = it.variable.events.migrateFrom();
          this.rootHolder.block.context.removeVariable(it.variable);
          variable.events.migrateTo(listeners);
        }
        this.rootHolder.block.context.addVariable(this.rootHolder.block.key, spec.name, variable, `PageManager page=${this.name} name=${spec.name}`);
        this.parameterVariables.splice(index, 1, {
          variable,
          writeable,
          val
        });
      } else if (it && it.val !== val) {
        it.writeable.set(val);
      }
    }
    (_this$registry3 = this.registry) === null || _this$registry3 === void 0 ? void 0 : _this$registry3.change({
      type: "page",
      op: "update",
      name: this.name
    });
  }
  updateParameters(params, currentPath) {
    var _this$registry4;
    let i = 0;
    for (let it of params) {
      const old = this.specHolder.spec.pathParam[i];
      if (old) {
        if (old.default !== it.default || old.name !== it.name) {
          this.updateParameter(i, it, currentPath);
        }
      } else {
        this.addParameter(it, currentPath);
      }
      ++i;
    }
    while (i < this.spec.pathParam.length) {
      this.removeParameter(this.spec.pathParam.length - 1, currentPath);
    }
    (_this$registry4 = this.registry) === null || _this$registry4 === void 0 ? void 0 : _this$registry4.change({
      type: "page",
      op: "update",
      name: this.name
    });
  }
  updateSpec(key, val) {
    var _this$registry5;
    let value = val;
    switch (key) {
      case "name":
        this.specHolder.spec.name = (value === null || value === void 0 ? void 0 : value.toLowerCase()) || "";
        break;
      case "parentContext":
        if (this.specHolder.spec.parentContext !== value) {
          this.specHolder.spec.parentContext = value || "root";
          if (this.rootHolder.block) {
            let context = this.rootHolder.block.getRootBlock().findNamedContext(value || "root");
            _BlockManager.BlockManager.migrateContext(this.rootHolder.block, this.rootHolder.block.context, context);
          }
        }
        break;
      case "title":
        this.specHolder.spec[key] = val;
        this.titleHolder.ref.updateParameter("template", val);
        this.titleHolder.ref.triggerDeps();
        break;
      default:
        this.specHolder.spec[key] = val;
        break;
    }
    (_this$registry5 = this.registry) === null || _this$registry5 === void 0 ? void 0 : _this$registry5.change({
      type: "page",
      op: "update",
      name: this.name
    });
  }
  onSpec(listener) {
    this.events.on("spec", listener);
    this.emitSpec();
  }
  offSpec(listener) {
    this.events.off("spec", listener);
  }
  emitSpec() {
    if (!this.effectHolder.effect) {
      this.effectHolder.effect = (0, _reactivity.effect)(() => {
        this.events.emit("spec", this.specHolder.spec);
      });
    } else {
      this.effectHolder.effect();
    }
  }
  toJSON() {
    var _this$spec$pathParam;
    return {
      name: this.name,
      layout: this.spec.layout,
      root: this.root.block ? this.root.block.toJSON().block : (0, _remeda.clone)(this.spec.root),
      parentContext: this.spec.parentContext,
      pathParam: ((_this$spec$pathParam = this.spec.pathParam) === null || _this$spec$pathParam === void 0 ? void 0 : _this$spec$pathParam.length) > 0 ? (0, _remeda.clone)(this.spec.pathParam) : undefined,
      title: this.spec.title
    };
  }
}
exports.PageManager = PageManager;
(0, _defineProperty2.default)(PageManager, "settings", [{
  title: "Page Settings",
  settings: {
    name: {
      type: "literal",
      title: "Name",
      description: "Name of this page, which is used in the link for the page right after the Palette name, eg. /palette2/my-palette/my-page.",
      required: true,
      valueType: "string",
      help: "Only letters, numbers and dashes '-' are allowed."
    },
    layout: {
      type: "select",
      title: "Page Layout",
      description: "How the page should be displayed when it's open.",
      enum: ["full", "modal", "modal-small", "modal-large"],
      default: "modal"
    },
    title: {
      type: "editor",
      title: "Page Title",
      editor: "markdown",
      inline: true,
      single: true
    }
  }
}, {
  title: "Page Variables",
  settings: {
    parentContext: {
      type: "context",
      title: "Parent Context",
      description: "The context in the main Palette to attach this page to. Variables from the parent context will be available to the page.",
      page: true,
      default: "root"
    },
    pathParam: {
      type: "mapping",
      title: "Link Variables",
      description: "Variables to get from the link of the page, appearing after the name of the page. For example, if a Palette called 'token' has a page called 'account', the link being /palette2/token/account/12 would make the first Link Variable '12'.",
      help: "help!",
      defaultName(index) {
        return "link" + (index + 1);
      },
      columnNames: ["Name", "Default Value"],
      keys: ["name", "default"]
    }
  }
}]);
function pageNamedContexts(block, checkConditional = true) {
  let contexts = [];
  let layer = [block];
  while (layer.length > 0) {
    let nextLayer = [];
    for (let it of layer) {
      if (checkConditional && it.type.conditional) {
        let ctxs = pageNamedContexts(it, false);
        ctxs.forEach(it => it.conditional = true);
        contexts = contexts.concat(ctxs);
      } else {
        if (it.context.ownerKey === it.key && it.context.name) {
          contexts.push({
            block: it,
            context: it.context,
            name: it.context.name,
            conditional: false
          });
        }
        nextLayer = nextLayer.concat(it.children);
      }
    }
    layer = nextLayer;
  }
  return contexts;
}
//# sourceMappingURL=PageManager.js.map